import { motion } from 'motion/react';

export function HealthDataNavigationSkeleton() {
  return (
    <div className="w-full">
      <div
        className="h-[46px] px-3 overflow-x-auto overflow-y-clip relative shrink-0 w-full [&::-webkit-scrollbar]:hidden"
        style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }}
      >
        <div className="absolute contents left-0 top-0">
          <div className="flex gap-[14px] items-start min-w-full lg:w-full w-max">
            {/* Create 5 skeleton buttons */}
            {Array.from({ length: 5 }, (_, index) => (
              <motion.div
                key={`skeleton-nav-${index}`}
                className="box-border flex gap-[10px] h-[42px] items-center justify-center
                  overflow-clip px-[18px] py-[13px] relative shrink-0 lg:flex-1 rounded-[4px]
                  bg-[rgba(255,255,255,0.15)] shadow-[0px_2px_48px_0px_rgba(0,0,0,0.04)]"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: index * 0.1 }}
              >
                <motion.div
                  className="h-[14px] bg-white/30 rounded"
                  style={{ width: `${80 + Math.random() * 40}px` }}
                />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}